import { Link } from 'react-router-dom';

interface BreadcrumbProps {
  items: { label: string; to?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs md:text-sm">
      <Link to="/" className="text-foreground-500 hover:text-primary-400 transition-colors">
        <i className="ri-home-4-line mr-1" />
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-500" />
          {item.to ? (
            <Link to={item.to} className="text-foreground-500 hover:text-primary-400 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}